import { proxy } from 'valtio';
import { FuiTabs2 } from '~/pages/heineken_template/components/FuiTabs2';
export const lung88988Stock_agentStore = proxy({
    realTimeType: 'long',
    transactionType: 'all',
    tabs1: new FuiTabs2(['熱門股', '主力當沖', '當日交易', '持倉中']),
    tabs2: new FuiTabs2(['龍王精選', '自選股']),
});
